import { useNostr } from '@nostrify/react';
import { useQuery } from '@tanstack/react-query';

import type { NostrEvent } from '@nostrify/nostrify';

/**
 * Fetch the public Ground feed — every practice completion shared to Nostr
 * under the `ground` hashtag. This is public UGC, so no author filtering.
 */
export function useGroundFeed() {
  const { nostr } = useNostr();

  return useQuery<NostrEvent[]>({
    queryKey: ['ground', 'feed'],
    queryFn: async (c) => {
      const events = await nostr.query(
        [{ kinds: [1], '#t': ['ground'], limit: 100 }],
        { signal: AbortSignal.any([c.signal, AbortSignal.timeout(10_000)]) },
      );

      const seen = new Set<string>();
      return events
        .filter((event) => {
          if (seen.has(event.id)) return false;
          seen.add(event.id);
          return event.content.trim().length > 0;
        })
        .sort((a, b) => b.created_at - a.created_at)
        .slice(0, 60);
    },
    refetchInterval: 30_000,
  });
}
